const getHaSwUrl = (baseDomain: string, isNext: number) =>
  `${baseDomain}/ha-sw-${isNext ? 'next' : 'precache'}.js`;
export { getHaSwUrl };
